import {apibaseURL,eStoragebaseURL, errorMessage,LOGOUT,RESET_DOCKET_DATA,S1,S2,S3,S4} from "../../config";
import { getCookie, deleteCookie, history } from "../../services/helper/Helper";
var crypto = require('crypto');

/**
 * Wrapper around fetch that intercepts 401/session-expired responses
 * and redirects to login instead of showing a broken page.
 */
function authenticatedFetch(url, options = {}) {
	return fetch(url, options).then(response => {
		if (response.status === 401 || response.status === 404) {
			// Check if this is a session expiry (not a public endpoint)
			const hasAuth = options.headers && options.headers['Authorization'];
			if (hasAuth || response.status === 401) {
				deleteCookie(btoa("publicAccess"));
				deleteCookie(btoa("TAWAJ"));
				history.push('/login');
				return Promise.reject(new Error('Session expired'));
			}
		}
		if (response.status === 500 || response.status === 502 || response.status === 503) {
			// Backend is down or erroring — treat as session failure
			const hasAuth = options.headers && options.headers['Authorization'];
			if (hasAuth) {
				deleteCookie(btoa("publicAccess"));
				deleteCookie(btoa("TAWAJ"));
				history.push('/login');
				return Promise.reject(new Error('Service unavailable'));
			}
		}
		return response;
	}).catch(error => {
		// Network error, timeout, or DNS failure — redirect to login
		deleteCookie(btoa("publicAccess"));
		deleteCookie(btoa("TAWAJ"));
		history.push('/login');
		return Promise.reject(error);
	});
}

export function encrypt(textToEncrypt) {
	if (textToEncrypt === null || textToEncrypt === undefined) {
		return '';
	}

	var encrypt = function (plain_text, encryptionMethod, sec, iv) {
		var encryptor = crypto.createCipheriv(encryptionMethod, sec, iv);
		return encryptor.update(plain_text, 'utf8', 'base64') + encryptor.final('base64');
	};
	
	var encryptionMethod = 'AES-256-CBC';
	var sec = S1+S2+S3+S4; //must be 32 char length
	var iv = sec.substr(0,16);
	
	var encryptedMessage = encrypt(textToEncrypt, encryptionMethod, sec, iv);

	return encryptedMessage;
}

export function decrypt(encryptedMessage) {
	if (!encryptedMessage || encryptedMessage === 0 || encryptedMessage === '0' || typeof encryptedMessage !== 'string') {
		return '0';
	}

	try {
		var decrypt = function (encryptedMessage, encryptionMethod, sec, iv) {
			var decryptor = crypto.createDecipheriv(encryptionMethod, sec, iv);
			return decryptor.update(encryptedMessage, 'base64', 'utf8') + decryptor.final('utf8');
		};
		
		var encryptionMethod = 'AES-256-CBC';
		var sec = S1+S2+S3+S4; //must be 32 char length
		var iv = sec.substr(0,16);
		
		var decryptedMessage = decrypt(encryptedMessage, encryptionMethod, sec, iv);
		
		return decryptedMessage;
	} catch(e) {
		console.warn('Decrypt failed:', e.message);
		return '0';
	}
}

export function getMydockets(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"getMydockets",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function getUniqueCaseid(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"getUniqueCaseid",
	{
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Authorization': `Bearer ${value}`
		},
	}
	)
	.then(response => response.json())
}
export function docketGeneralInfo(data) {
	let value=getCookie(btoa("TAWAJ"));
	let paramData = encrypt(JSON.stringify(data));
	return authenticatedFetch(apibaseURL+"docketGeneralInfo",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: paramData
	}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		if(!response) return null; response = response.response;
		if(response && response != 0 && response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function getPartyInfo(data) {
	let value=getCookie(btoa("TAWAJ"));

	let paramData = encrypt(JSON.stringify(data));
	return authenticatedFetch(apibaseURL+"getPartyInfo",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: paramData
	}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		if(!response) return null; response = response.response;
		if(response && response != 0 && response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function documentTypes() {
	let value=getCookie(btoa("TAWAJ"));
  	return authenticatedFetch(apibaseURL+"getDocumentTypes",
  	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => response.json())
}
export function getDocketsList() {
	let value=getCookie(btoa("TAWAJ"));

	return  authenticatedFetch(apibaseURL+"getDocketsList", {
	headers: {
		'Authorization': `Bearer ${value}`
	}
	}).then(response => response.json());

	 
//   return fetch(apibaseURL+"getDocketsList")
// 	.then(response => response.json())
}
export function externalPendingRejectedDocs(data) {
	let value=getCookie(btoa("TAWAJ"));
  	return authenticatedFetch(apibaseURL+"getExternalPendingRejectedDocs",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function getUserData() {
	let value=getCookie(btoa("TAWAJ"));
  	return authenticatedFetch(apibaseURL+"getUserDetails", 
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	  })
	  .then(response => {
			// You can work with 'data' here
			if(!response) return null; response = response.response;
		    if(response && response != 0 && response != '0') {
				response = decrypt(response);
				response = JSON.parse(response);
			}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	  })
	  .catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	  });
}
export function getCurrentUserData() {
	let value=getCookie(btoa("TAWAJ"));
  	return authenticatedFetch(apibaseURL+"getUserSessionDetails", 
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		if(response.status == 401 || response.status == '401') {
			if(deleteCookie(btoa("publicAccess")) && deleteCookie(btoa("TAWAJ"))) {
			  history.push('/login');
				//   dispatch(userLogout())
				//   dispatch({type:RESET_DOCKET_DATA})
			} else {
			  //dispatch(notification(errorMessage.tryAgain))
			}

			return false;

		} else if(response.error == 'Unauthorized or session is expired') {
			if(deleteCookie(btoa("publicAccess")) && deleteCookie(btoa("TAWAJ"))) {
				history.push('/login');
			  	//   dispatch(userLogout())
			  	//   dispatch({type:RESET_DOCKET_DATA})
			}

			return false;
		}

		// Parse the JSON data from the response
		return response.json();
	  })
	  .then(response => {
			// You can work with 'data' here
			if(!response) return null; response = response.response;
		    if(response && response != 0 && response != '0') {
				response = decrypt(response);
				response = JSON.parse(response);
			}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	  })
	  .catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	  });
}
function userLogout() {
	return {
    type: LOGOUT
  }
}
export function caseidExists() {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"caseidExists",
	{
		headers: {
			'Authorization': `Bearer ${value}`
		}
	})
	.then(response => response.json())
}
export function logoutUser() {
	return fetch(apibaseURL+"logoutUser",
	{})
	.then(response => response.json())
}
export function addUser(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"addUser",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)
	}
	)
	.then(response => response.json())
}
export function isUserexists(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"isUserexists",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function sendForgotPasswordLink(data) {
	return fetch(apibaseURL+"sendForgotPasswordLink",
	{method: 'POST',body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function resetOldPassword(data) {
	return fetch(apibaseURL+"resetUserPassword",
	{method: 'POST',body: data}
	)
	.then(response => response.json())
}
export function updateUserData(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"updateUserData",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}
export function uploadDocs(data) {
//	return fetch('https://staging.osah.ga.gov/osah-public-access/uploaddocs',
	let value=getCookie(btoa("TAWAJ"));
	//let testData = encrypt(data);
	return authenticatedFetch(apibaseURL+"uploadDocs",
		{
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${value}`
			},
			body: data
		}
	)
	//.then(response => response.json())
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	})
	.then(response => {
		// You can work with 'data' here
		if(!response) return null; response = response.response;
		if(response && response != 0 && response != '0') {
			response = decrypt(response);
			response = JSON.parse(response);
		}
		// Now, 'response' contains the parsed JSON result
		//console.log(response,7800);

		return response;
	})
	.catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	});
}
export function isFileExists(data) {
	let value=getCookie(btoa("TAWAJ"));
	let testData = encrypt(data);
	//console.log(testData);
	 return authenticatedFetch(apibaseURL+"isFileExists",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: testData
	}
	).then(response => response.json())
	
}
export function documentActivities() {
	let value=getCookie(btoa("TAWAJ"));
  return authenticatedFetch(apibaseURL+"getDocumentsActivity",
    {
		
		headers: {
			'Authorization': `Bearer ${value}`
		}
		
	})
	.then(response => response.json())
}
export function getDocumentPreview(data) {
	let value=getCookie(btoa("TAWAJ"));
	let testData = encrypt(data);
 return authenticatedFetch(apibaseURL+"documentPreview",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: testData
	}
	)
	.then(response => response.json())
}

export function updateEservicePreference(data) {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"updateEservicePreference",
	{
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${value}`
		},
		body: JSON.stringify(data)}
	)
	.then(response => response.json())
}

// export function checkLoggedInUser() {
// 	let value=getCookie(btoa("TAWAJ"));
// 	return fetch(apibaseURL+"checkLoggedInUser",
// 	{
// 		method: 'POST',
// 		headers: {
// 			'Authorization': `Bearer ${value}`
// 		},
// 		body: JSON.stringify({})}
// 	)
// 	.then(response => {
// 		console.log(response,909090);
// 		// Check if the response status indicates success (e.g., 200 OK)
// 		if (!response.ok) {
// 		  throw new Error('Network response was not ok');
// 		}
// 		if(response.user_id == '0' || response.user_id == 0) {
// 			history.push('/login');
// 			return false;
// 		}
// 		// Parse the JSON data from the response
// 		return response.json();
// 	  })
// }

export function checkLoggedInUser() {
	let value=getCookie(btoa("TAWAJ"));
	return authenticatedFetch(apibaseURL+"checkLoggedInUser",
	{
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${value}`
			},
			body: JSON.stringify({})}
	)
	.then(response => {
		// Check if the response status indicates success (e.g., 200 OK)
		if (!response.ok) {
		  throw new Error('Network response was not ok');
		}

		// Parse the JSON data from the response
		return response.json();
	  })
	  .then(response => {
		if(response.user_id == '0' || response.user_id == 0 || response.code == 401 || response.code == '401') {
			return response;
		}
		return response;
	  })
	  .catch(error => {
		// Handle any errors that occurred during the fetch or JSON parsing
		console.error('There was a problem with the fetch operation:', error);
	  });
}

